<table mat-table matSort [matSortActive]="sortInitialState?.field ?? ''" [matSortDirection]="sortInitialState?.direction ?? ''" [dataSource]="data()" (matSortChange)="handleSortEvent($event)" class="h-full" aria-describedby="tabella">
  <ng-content></ng-content>
  <ng-container matColumnDef="selectElementt">
    <th mat-header-cell *matHeaderCellDef>
      Seleziona 
      <mat-checkbox (change)="$event ? toggleAllRows() : null"
                    [checked]="selection.hasValue() && isAllSelected()"
                    [indeterminate]="selection.hasValue() && !isAllSelected()">
      </mat-checkbox>
    </th>
    <td mat-cell *matCellDef="let el">
      <mat-checkbox (click)="$event.stopPropagation();checkClicked()"
                    (change)="$event ? selection.toggle(el) : null"
                    [checked]="selection.isSelected(el)">
      </mat-checkbox>
    </td>
  </ng-container>
  @for (column of columns; track column.name; let first=$first) {
    <ng-container [matColumnDef]="column.name" [sticky]="column.sticky || false">
      <th mat-header-cell *matHeaderCellDef [mat-sort-header]="column.name" [disabled]="column.sortable === false" [ngClass]="column.headerClasses" [class]="defaultHeaderClass">
        <span [ngClass]="column.headerLabelClasses">{{column.label}}</span>
      </th>
      <td mat-cell *matCellDef="let element" [ngClass]="column.classes"    [style]="getStyles(element, column)">
        <span *ngIf="!column.cell">{{column.type === 'date' ? (element[column.name] | date: 'dd/MM/yyyy') : (column.type === 'datetime' ? (element[column.name] | date: 'dd/MM/yyyy HH:mm') : element[column.name])}}</span>
        <span *ngIf="column.cell" [innerHTML]="column.type === 'date' ? (column.cell(element) | date: 'dd/MM/yyyy') : (column.type === 'datetime' ? (column.cell(element) | date: 'dd/MM/yyyy HH:mm') : column.cell(element)) | appSafeHtml"></span>
      </td>
    </ng-container>
  }
  <ng-container matColumnDef="conditionalButton" *ngIf="showButtonInsert">
    <th mat-header-cell *matHeaderCellDef> <span>{{typeTitleInsert}} {{insertFormTitle}}</span> </th>
    <td mat-cell *matCellDef="let element"> 
      <app-button  [icon]="typeIconInsert" [fullWidth]="false" miniFab (click)="onInsertClick(element, insertRef!)"></app-button>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="visibleColumns(); sticky: true;" class="surface-50"></tr>
  <tr
    mat-row
    (click)="onRowClick(row)"
    *matRowDef="let row; let odd = odd; columns: visibleColumns();"
    [class.bg-blue-50]="odd"
    [class.cursor-pointer]="rowClick"
  ></tr>
  <tr class="mat-row surface-ground" *matNoDataRow>
    <td class="mat-cell surface-ground" [attr.colspan]="visibleColumns().length">
      <app-empty-list ></app-empty-list>
    </td>
  </tr>
</table>

<ng-template #insertRef *ngIf="showButtonInsert">
  <app-sidenav [title]="typeTitleInsert +' '+ insertFormTitle" [padding]="0" [className]="'w-full'">
    <div class="flex flex-column gap-3 align-items-center w-full">
      <div #insertFormRef class="w-full p-2">
        <ng-content select="[insert-form]"></ng-content>
      </div>
    </div>
    <div footer>
      <div class="flex justify-content-center">
        <app-button label="Salva" raised fullWidth cdkFocusRegionstart (click)="onSaveClick()" [disabled]="!insertForm?.valid"></app-button>
      </div>
    </div>
  </app-sidenav>
</ng-template>